export default __webpack_public_path__ + "static/media/exterior1_2020.3f7fac84.jpeg";